import { IBookingArrivalSignalR, IStore } from "helpers";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { set } from "lodash";

export const notificationReducer = createSlice({
  name: "notification store",
  initialState: {
    generatedReport: null,
    alertToLotEmailCms: null,
    editedFarmGroupId: null,
    timeStamp : null,
    clientId: null,
    pgaFormEditing: null,
    pgaFormReviewing: null,
    hasNewBooking: null,
    bookingArrival: null,
  },
  reducers: {
    newGeneratedReport: (state, action) => {
      state.generatedReport = action.payload;
    },
    newAlertToLotEmailCms: (state, action) => {
      state.alertToLotEmailCms = action.payload;
    },
    setEditedFarmGroupId: (state, action) => {
      state.editedFarmGroupId = action.payload;
    },
    setTimeStamp: (state, action) => {
      state.timeStamp = action.payload;
    },
    setClientId: (state, action) => {
      state.clientId = action.payload;
    },
    setPgaFormEditing: (state, action) => {
      state.pgaFormEditing = action.payload;
    },
    setPgaFormReviewing: (state, action) => {
      state.pgaFormReviewing = action.payload;
    },
    setHasNewBooking: (state, action) => {
      state.hasNewBooking = action.payload;
    },
    setBookingArrival: (
        state,
        action: PayloadAction<IBookingArrivalSignalR>
    ) => {
        state.bookingArrival = action.payload;
    },
  },
});
export const { newGeneratedReport,
  newAlertToLotEmailCms,
  setEditedFarmGroupId,
  setTimeStamp,
  setClientId,
  setPgaFormEditing,
  setPgaFormReviewing,
  setHasNewBooking,
  setBookingArrival } =
  notificationReducer.actions;

export const getNewNotification = (state: IStore) =>
  state.notification.generatedReport;

export const getNewAlertToLotEmailCms = (state: IStore) =>
  state.notification.alertToLotEmailCms;

export const getEditedFarmGroupId = (state: IStore) =>
  state.notification.editedFarmGroupId;

export const getTimeStamp = (state: IStore) =>
  state.notification.timeStamp;
export const getClientId = (state: IStore) =>
  state.notification.clientId;
export const getPgaFormEditing = (state: IStore) =>
  state.notification.pgaFormEditing;

export const getPgaFormReviewing = (state: IStore) =>
  state.notification.pgaFormReviewing;

export const getHasNewBooking = (state: IStore) =>
  state.notification.hasNewBooking;

export const getBookingArrival = (state: IStore) =>
  state.notification.bookingArrival;

export default notificationReducer.reducer;
